import React, { useEffect } from 'react'
import styles from "./UniversityList.module.css";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'

import { getUniversity } from '../../../../actions/report';

// import BtnBack from '../../helper/btnBackMTO/BtnBack';
import GetHeader from '../../helper/getHeader/GetHeader';

import bg from '../../../../assets/dashboard/background_1.png'
import logo_big from '../../../../assets/dashboard/logo_big.png'

const UniversityList = ({
  university,
  getUniversity,
  location
}) => {

  useEffect(() => {
    getUniversity();
  }, [])

  const getColor = (color) => {
    return color == '#5b1900' ? '#fff' : '#000';
  }

  const fromIndicators = location.state?.fromIndicators

  return (
    <div className={styles.wrapper}>
      <img src={bg} className={styles.bg} />
      <div className={styles.logo_bigWrapper}>
        <img src={logo_big} className={styles.logo_big} />
      </div>
      <GetHeader title={<>СЕТЬ ОБРАЗОВАТЕЛЬНЫХ ОРГАНИЗАЦИЙ ВЫСШЕГО ОБРАЗОВАНИЯ <br /> МИНОБОРОНЫ РОССИИ</>} />

      <div className={styles.wrapperBlock}>
        {
          university && university?.map((el, inx) => {
            const firstLevelLink = fromIndicators
              ? `/dashboard/indicators/activity/${inx}`
              : `/dashboard/mto/${inx}`
            return (
              <div className={styles.wrapperList} key={el.name}>
                <Link to={firstLevelLink}>
                  <div
                    // style={{ backgroundColor: el.color, color: getColor(el.color) }}
                    className={styles.item}
                  >
                    <div style={{ width: '21vw' }}>
                      <p>{el.name}</p>
                    </div>

                    {el.api_url.length > 1 &&
                      <img className={styles.item_logo} src={`${el.api_url}company/gou_logo`} />}
                  </div>

                </Link>
                {/* {el?.branches.map((_el, _inx) => {
                  const secondLevelLink = fromIndicators
                    ? `/dashboard/indicators/activity/${inx}_${_inx}`
                    : `/dashboard/list/${inx}_${_inx}`
                  return (
                    <Link to={secondLevelLink}>
                      <div
                        style={{ backgroundColor: _el.color, color: getColor(_el.color) }}
                        className={styles.branch}
                        key={_el.name}>
                        {_el.name}
                      </div>
                    </Link>
                  )
                })} */}
              </div>
            )
          })
        }
      </div>

      {/* <BtnBack /> */}
    </div>
  )
}


const mapStateToProps = (state) => ({
  university: state.report.university,
  auth: state.auth
});

export default connect(mapStateToProps, {
  getUniversity
})(UniversityList);